import styled from "styled-components";

export const Container = styled.section`
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
`;

export const Heading = styled.h3`
  margin: 0 0 16px;
  padding: 0 16px;
  font-size: 18px;
  font-weight: 900;
  color: #000000;
`;

export const ScrollRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  gap: 8px;
  padding-left: 16px;
  padding-right: 16px;
  scroll-behavior: smooth;
  overscroll-behavior-x: contain;
`;

export const SearchCard = styled.button`
  flex: 0 0 auto;
  border: 1px solid #008cff;
  background: #fff;
  border-radius: 16px;
  padding: 8px 12px;
  text-align: left;
  min-width: 144px;
  height: 82px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
`;

export const PlanType = styled.div`
  font-size: 10px;
  font-weight: 900;
  color: #008cff;
`;

export const Destination = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #000000;
`;

export const Meta = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #4a4a4a;
`;

export const DateText = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #757575;
`;

